import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GeneralElementSettings, SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { ImgDirective } from 'src/layout/media/directives/img.directive';

export interface ImageSettings extends GeneralElementSettings {
    imageMaxWidth?: string;
    alt?: string;
    link?: string;
}

@Component({
    selector: 'image-element',
    template: `
    <a [routerLink]="settings?.link"
       *ngIf="settings?.link; else imgTemplate">
        <img [use]="media"
             fit="width"
             [srcset]="srcset"
             [size]="size?.length > 0 ? size : imgSize"/>
    </a>
    <ng-template #imgTemplate>
        <img [use]="media"
             fit="width"
             [srcset]="srcset"
             [size]="size?.length > 0 ? size : imgSize"/>
    </ng-template>
    `,
    styles: `
    :host {
        background-color: var(--background-color);
        color: var(--color);
        display: flex;
        margin: auto;
        max-width: var(--content-width);
        width: 100%;

        &.big {
            width: 100%;
        }
        &.large {
            width: clamp(700px, 80%, 2000px);
        }
        &.medium {
            width: clamp(500px, 60%, 1500px);
        }
        &.small {
            width: clamp(450px, 30%, 700px);
        }
        &.extra-small {
            width: clamp(300px, 20%, 500px);
        }
    }

    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 100%;



        &[src='/dist/assets/no-image.svg'] {
            margin: auto;
            width: 15rem;
        }
    }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageElementComponent extends SettingsSetterDirective {
    media: UmbracoImage;
    mediaMobile?: UmbracoImage;
    size: string;
    declare settings: ImageSettings;
    imgSize: string;
    srcset: string;
    // content-full
    // content-half
    // content-third
    // content-quart

    ngOnInit(): void {
        super.ngOnInit()
        let _elm = this.elm.nativeElement;
        _elm.style.aspectRatio = (this.media?.aspectRatio ?? '1')?.replace(':', '/');
        if (_elm.closest('app-carousel-simple') != null)
            this.imgSize = 'content-quart';
        else
            this.imgSize = 'content-full';


        let backgroundImageUrl = new URL(this?.media?.imageUrl);
        let backgroundImageMobileUrl = new URL(this?.mediaMobile?.imageUrl ?? this?.media?.imageUrl);
        Object
            .entries(Object.assign({}, ImgDirective.QUERY_ENTRIES))
            .forEach(([key, value]) => {
                backgroundImageUrl.searchParams.set(key, value);
                backgroundImageMobileUrl.searchParams.set(key, value);
            });

        this.srcset = [
            ImgDirective._sourceSet(backgroundImageMobileUrl, null, SettingsSetterDirective.SRCSET_SIZES.mobile ?? []),
            ImgDirective._sourceSet(backgroundImageUrl, null, SettingsSetterDirective.SRCSET_SIZES.desktopM ?? []),
        ]
            .join(',')
    }

}

